import React,{ useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ServiceEdit from "./Components/ServiceEdit";
import Loader from "./Components/Loader";

const ServiceEditPage=()=>{
    useEffect(()=>{
        document.title="Edit Service | Janushree"
      },[]);

    return(
        <>
            <Header/>
            <ServiceEdit/>
            <Loader/>
            <Footer/>
        </>
    );
}

export default ServiceEditPage;